import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";
import { changeJob } from "../redux/features/Job/jobSlice"


export default function EditJob() {
  const navigate = useNavigate();
  const { editing } = useSelector(state => state.jobs) || {}
  const dispatch = useDispatch()

  useEffect(() => {
    if (editing.id){
      setInput(editing)
    }else{ navigate("/") }
  }, [editing, navigate])

  const [input, setInput] = useState({
    title: "",
    salary: "",
    type: "",
    deadline: ""
  })

  const InputChangeHandler = (e, name) => {
    setInput((prev) => {
      return { ...prev, [name]: e.target.value }
    })
  }

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(changeJob({id: editing.id, data: input}))
    .then((()=>{
      navigate("/")
    }))
  }
  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={submitHandler}>
          <div className="fieldContainer">
            <label htmlFor="lws-JobTitle" className="text-sm font-medium text-slate-300">Job Title</label>
            <select id="lws-JobTitle" name="lwsJobTitle" required
              value={input.title}
              onChange={(e) => InputChangeHandler(e, "title")}
            >
              <option value="" hidden>Select Job</option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select id="lws-JobType" name="lwsJobType" required
              value={input.type}
              onChange={(e) => InputChangeHandler(e, "type")}
            >
              <option value="" hidden>Select Job Type</option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input type="number" name="lwsJobSalary" id="lws-JobSalary" required className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={input.salary}
                onChange={(e) => InputChangeHandler(e, "salary")}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input type="date" name="lwsJobDeadline" id="lws-JobDeadline" required
              value={input.deadline}
              onChange={(e) => InputChangeHandler(e, "deadline")}
            />
          </div>

          <div className="text-right">
            <button type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
              Edit
            </button>
          </div>
        </form>
      </div>
    </main>
  )
};